import React from 'react';
import SelectCreatable from 'react-select/creatable';
import withSelectWrapper from '../enhancers/WithSelectWrapper';

const SelectWithWrapper = withSelectWrapper(SelectCreatable);

const SelectWithInput = props => <SelectWithWrapper {...props} />;

export default SelectWithInput;
